import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'

const LIMIT_SCREEN_DESKTOP = 720

const MobileContext = createContext<{ isMobile: boolean }>({ isMobile: false })

export const useMobile = () => {
  const context = useContext(MobileContext)
  if (!context) {
    throw new Error('useMobile must be used within a MobileProvider')
  }
  return context
}

export const MobileProvider = ({ children }: { children: React.ReactNode }) => {
  const [isMobile, setIsMobile] = useState<boolean>(
    () => window.innerWidth <= LIMIT_SCREEN_DESKTOP,
  )

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= LIMIT_SCREEN_DESKTOP)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const value = useMemo(() => ({ isMobile }), [isMobile])

  return (
    <MobileContext.Provider value={value}>{children}</MobileContext.Provider>
  )
}
